import React from "react";
import "../Director/Director.css";
import FounderImg from "../../../../../assets/ihn/team/founderimg.webp";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faLinkedinIn } from "@fortawesome/free-brands-svg-icons";
import Linkedin from "../../../../../assets/logo/linkedin.webp"
import TeamLead from "../Team-Lead/TeamLead";



export default function Founder() {
  return (
    // <div className="page-content">
    //   <section className="director-page">

    //     <div className="director-container">

    //       {/* LEFT : IMAGE */}
    //          <div className="founder-image-wrapper">
    //         <img src={FounderImg} alt="Abhishek Garg - Founder" className="founder-main-image" />
            
    //         {/* NEW POSITIONING - ABOVE IMAGE BOTTOM-RIGHT */}
    //         <a
    //           href="https://www.linkedin.com/in/abhigroup"
    //           target="_blank"
    //           rel="noreferrer"
    //           className="founder-linkedin-overlay"
    //         >
    //           <img src={Linkedin} className="founder-linkedin-icon" alt="LinkedIn" />
    //         </a>
    //       </div>

    //       {/* RIGHT : SHORT CONTENT */}
    //       <div className="director-content">
    //         <h1 className="director-title"> The Founder</h1>
    //         <h2 className="director-name">Abhishek Garg</h2>
    //         <p>
    //           Abhishek Garg is a lifelong innovator who has spent over 25 years at the forefront of the events and experiential industry. From his beginnings in the high-stakes world of physical weddings and corporate milestones to founding a premier online wedding platform, Abhishek has pioneered the digital evolution of the sector. Today, his platform hosts over 15,000 vendors, ranking among India’s top wedding planners through purely organic growth.
    //         </p>

    //         <p>
    //           With a diverse portfolio spanning Events, Publishing, Real Estate, and Organic Products, Abhishek’s most personal venture is IHN. Launched during the challenges of the pandemic, IHN has blossomed into a thriving ecosystem where business synergies and collaborative success are the new standard. Inspired by the visionary drive of figures like Elon Musk, Abhishek combines a razor-sharp intellect with a deeply humane, down-to-earth approach. He remains dedicated to breaking business barriers while maintaining a core mission of giving back to the universe.
    //         </p>
    //       </div>

    //     </div>
    //   </section>
    // </div>
    <div className="page-content">
 <TeamLead defaultTab="founder" />

    </div>
  
  );
};

